module.exports = __webpack_public_path__ + "static/media/zbhy_bg.5c250241.png";